/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Title from '../typography/Title';

// import testImage from '../../../img/logo-projections-new.png';
import styles from '../../../styles/blocks/downloads.module.css';

const propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    isLeftAligned: PropTypes.bool,
    withoutLines: PropTypes.bool,
    padded: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function DownloadsBlock({
    title = null,
    items = null,
    isLeftAligned = false,
    withoutLines = false,
    padded = false,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [styles.isLeftAligned]: isLeftAligned,
                    [styles.withoutLines]: withoutLines,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {title !== null ? (
                    <Title className={styles.title} size="small">
                        {title}
                    </Title>
                ) : null}
                <div className={styles.items}>
                    {(items || []).map((item, index) => {
                        const { label, url, media = null } = item || {};
                        const key = `${label}-${index + 1}`;
                        const { url: mediaUrl = null } = media || {};
                        return url !== null || mediaUrl !== null ? (
                            <a
                                key={key}
                                className={styles.item}
                                href={mediaUrl || url}
                                target="_self"
                                download
                            >
                                {label}
                            </a>
                        ) : (
                            <div className={styles.item} key={key}>
                                {label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

DownloadsBlock.propTypes = propTypes;

export default DownloadsBlock;
